export interface EntityWithIdAndTimestamp {
  id: string;
  _rowTimestamp: string | null;
}

export const toSelection = (entity: EntityWithIdAndTimestamp) => ({
  id: entity.id,
  rowTimestamp: entity._rowTimestamp!!,
});
